function authHeaders(extra = {}) {
  const token = localStorage.getItem('ra_token');
  const headers = { ...extra };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
}

async function authFetch(url, options = {}) {
  const headers = authHeaders(options.headers || {});
  const res = await fetch(url, { ...options, headers });
  if (res.status === 401) {
    localStorage.removeItem('ra_token');
    window.location.href = '/login';
    return null;
  }
  return res;
}

export async function fetchPortfolio() {
  const res = await authFetch('/api/portfolio');
  if (!res) return [];
  return res.json();
}

export async function addHolding(ticker, shares, buyPrice, broker, currency) {
  const res = await authFetch('/api/portfolio', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ticker, shares, buy_price: buyPrice, broker: broker || '', currency: currency || '' }),
  });
  if (!res) return {};
  return res.json();
}

export async function deleteHolding(ticker) {
  const res = await authFetch(`/api/portfolio/${encodeURIComponent(ticker)}`, { method: 'DELETE' });
  if (!res) return {};
  return res.json();
}

export async function importHoldings(holdings, broker = '', currency = '') {
  const res = await authFetch('/api/portfolio/import', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ holdings, broker, currency }),
  });
  if (!res) return {};
  return res.json();
}

export async function fetchWatchlist() {
  const res = await authFetch('/api/watchlist');
  if (!res) return [];
  return res.json();
}

export async function addToWatchlist(symbol) {
  const res = await authFetch('/api/watchlist', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ symbol }),
  });
  if (!res) return {};
  return res.json();
}

export async function removeFromWatchlist(symbol) {
  const res = await authFetch(`/api/watchlist/${encodeURIComponent(symbol)}`, { method: 'DELETE' });
  if (!res) return {};
  return res.json();
}

export async function fetchQuote(ticker) {
  const res = await authFetch(`/api/stock/quote/${encodeURIComponent(ticker)}`);
  if (!res || !res.ok) return null;
  return res.json();
}

export async function fetchPrice(ticker) {
  const res = await authFetch(`/api/stock/price/${encodeURIComponent(ticker)}`);
  if (!res || !res.ok) return null;
  return res.json();
}

export async function fetchHistory(ticker, period, interval) {
  const res = await authFetch(`/api/stock/history/${encodeURIComponent(ticker)}?period=${period}&interval=${interval}`);
  if (!res || !res.ok) return null;
  return res.json();
}

export async function fetchSparkline(ticker) {
  const res = await authFetch(`/api/stock/sparkline/${encodeURIComponent(ticker)}`);
  if (!res) return {};
  return res.json();
}

export async function fetchIndices() {
  const res = await authFetch('/api/market/indices');
  if (!res) return {};
  return res.json();
}

export async function fetchScreener(sector, market, live) {
  const params = new URLSearchParams({ sector, market, live: live ? 'true' : 'false' });
  const res = await authFetch(`/api/screener?${params}`);
  if (!res) return {};
  return res.json();
}

export async function fetchPlatforms() {
  const res = await authFetch('/api/platforms');
  if (!res) return [];
  return res.json();
}

export async function parseCSV(file) {
  const formData = new FormData();
  formData.append('file', file);
  const token = localStorage.getItem('ra_token');
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch('/api/portfolio/parse-csv', { method: 'POST', body: formData, headers });
  if (res.status === 401) { localStorage.removeItem('ra_token'); window.location.href = '/login'; return {}; }
  return res.json();
}

export async function autoDetectColumns(columns, platform) {
  const res = await authFetch('/api/portfolio/auto-detect-columns', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ columns, platform }),
  });
  if (!res) return {};
  return res.json();
}

export function detectCurrency(ticker) {
  return ticker.toUpperCase().endsWith('.TO') ? 'CAD' : 'USD';
}

export function cadToUsd(amount) {
  return amount / 1.36;
}

export async function fetchPortfolioSentiment() {
  const res = await authFetch('/api/sentiment/ai/portfolio');
  if (!res) return {};
  return res.json();
}

export function formatMcap(v) {
  if (!v || v === 0) return '—';
  if (v >= 1e12) return `${(v / 1e12).toFixed(2)}T`;
  if (v >= 1e9) return `${(v / 1e9).toFixed(2)}B`;
  if (v >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
  return v.toLocaleString();
}

export { authHeaders };
